import React from "react";
import { Award as AwardIcon } from "lucide-react";
import { awards } from "../mock";
import Reveal from "./Reveal";

const Awards = () => {
  return (
    <section id="awards" className="bg-white">
      <div className="max-w-4xl mx-auto px-4 py-20">
        <Reveal className="text-center mb-12">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">Recognition</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide text-navy mt-2">Awards & Honors</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <div className="space-y-4">
          {awards.map((a, i) => (
            <Reveal key={i} delay={1}>
              <div className="group flex gap-5 bg-cream rounded-2xl border border-black/5 p-6 transition-all duration-300 hover:shadow-md hover:-translate-y-0.5">
                <div className="w-14 h-14 rounded-xl bg-navy flex items-center justify-center shrink-0 transition-colors group-hover:bg-gold">
                  <AwardIcon className="w-7 h-7 text-gold transition-colors group-hover:text-navy" />
                </div>
                <div>
                  <div className="flex flex-wrap items-center gap-x-3">
                    <h3 className="font-head text-xl uppercase tracking-wide text-navy">{a.title}</h3>
                    <span className="text-[11px] font-bold tracking-widest uppercase text-gold">{a.year}</span>
                  </div>
                  <p className="text-sm font-semibold text-navy/70 mt-0.5">{a.org}</p>
                  <p className="text-sm text-gray-600 mt-2">{a.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Awards;
